import { Platform } from 'react-native';

/**
 * Returns props object only for web platform.
 */
export function webOnlyProps(props: Record<string, unknown>) {
  return Platform.OS === 'web' ? props : {};
}
